module.exports = __webpack_public_path__ + "static/media/Spanish-Ordinal-number.f36810b2.jpg";